export default {
    props: {
        tooltipEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.enabled'
        }, 
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        }, 
        tooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/Common/Tooltip.js